import { useEffect, useRef, useState } from 'react';

export function useDebouncedResizeObserver<T extends HTMLElement>(debounceDelay = 200) {
  const ref = useRef<T | null>(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    let timeoutId: NodeJS.Timeout | null = null;

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;

        // Debounce the size update
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
          setSize({ width, height });
        }, debounceDelay);
      }
    });

    observer.observe(element);

    // eslint-disable-next-line consistent-return
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      observer.disconnect();
    };
  }, [debounceDelay]);

  return { ref, ...size };
}
